import { Component, OnInit, Inject, Output, EventEmitter, inject } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';

@Component({
  selector: 'app-bottom-sheet-save-cancel',
  // standalone: true,
  // imports: [],
  templateUrl: './bottom-sheet-save-cancel.component.html',
  styleUrl: './bottom-sheet-save-cancel.component.css'
})
export class BottomSheetSaveCancelComponent implements OnInit {

  @Output() 
  public actionClicked = new EventEmitter<string>();
  @Inject(MAT_BOTTOM_SHEET_DATA) 
  public data: string | undefined;

  public message: string = 'Wollen Sie die Änderungen speichern?';
  public saveDisabled = false;
  
  private bottomSheetRef = inject<MatBottomSheetRef<BottomSheetSaveCancelComponent>>(MatBottomSheetRef);
 
  constructor() {
  }

  ngOnInit() {
    if (this.data) {
      this.message = this.data;
    } 
  }

  cancelClick(): void {
    this.bottomSheetRef.dismiss({
      action: 'Cancel',
    });
  }

  saveClick() {
    this.actionClicked.emit("save");
  }

}
